import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import DataTableBloc from '../Blocs/DetailPegawaiBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

const reformatDate = (date, withDay = true) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
}

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historyPresensiKepegawaianTableActive'
    defaultOrder = 'presensi_result_id'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let filter = this.props.filter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...filter,
            uuid : this.props.uuid
        }
        await this.dataTableBloc.fetchListPresensi(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "presensi_result_date",
            text: "Tanggal",
            sortable: true,
            width: '15%',
            cell: record => {
                return reformatDate(record.presensi_result_date)
            }
        },
        {
            key: "presensi_result_checkin",
            text: "Jam Masuk",
            sortable: true,
            width: '15%',
        },
        {
            key: "presensi_result_checkout",
            text: "Jam Keluar",
            sortable: true,
            width: '15%',
        },
        {
            key: "kekuarangan_jam_kerja",
            text: "Kekurangan Jam Kerja",
            className: "kekuarangan_jam_kerja",
            sortable: true,
            width: '15%',
        },
        {
            key: "presensi_result_late",
            text: "Keterlambatan",
            sortable: true,
            width: '15%',
        },
        {
            key: "presensi_result_early",
            text: "Pulang Cepat",
            sortable: true,
            width: '15%',
        },
        {
            key: "presensi_result_type_name",
            text: "Jenis Izin",
            className: "text-center",
            sortable: true,
            width: '15%',
        },
        {
            key: "presensi_result_description",
            text: "Keterangan",
            sortable: true,
            align: 'center',
            width: 120,
        },
        // {
        //     key: "action",
        //     text: "Action",
        //     className: "action",
        //     width: 120,
        //     sortable: false,
        //     align: 'center',
        //     cell: record => {
        //         const thisId = record.presensi_id
        //         return (
        //             <Fragment>
        //                 <span>
        //                     <button
        //                         className="btn btn-primary btn-sm"
        //                         id={"detail-" + thisId}
        //                         onClick={() => {
        //                             this.setState({
        //                                 detailUuid: record.presensi_uuid
        //                             })
                                    
        //                             // set current employee uuid selected
        //                             let dataUser = {
        //                                 presensi_uuid: record.presensi_uuid,
        //                                 // employee_name : record.employee_name,
        //                                 // employee_current_position_name : record.employee_current_position_name,
        //                                 // employee_nip : record.employee_nip
        //                             }
        //                             localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
        //                         }}
        //                         style={{
        //                             marginRight: '2px',
        //                             padding: '2px 5px'
        //                         }}>
        //                             <i className="uil-file-search-alt"></i>
        //                     </button>
        //                     <Tooltip
        //                         style={{
        //                             marginBottom: 2
        //                         }}
        //                         placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
        //                         toggle={() => {
        //                             this.setState({
        //                                 ["detail" + thisId] : !this.state["detail" + thisId]
        //                             })
        //                         }}
        //                     >Lihat</Tooltip>
        //                 </span>
        //             </Fragment>
        //         );
        //     }
        // }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/presensi.html?detail&uuid=" + this.state.detailUuid}/>
                : null }
                {/* { this.state.updateUuid !== null ?
                    <Redirect to={"/kepegawaian/home.html?update&uuid=" + this.state.updateUuid}/>
                : null } */}
            </>
        )
    }

}

export default TableActiveComponent